module.exports = __webpack_public_path__ + "img/New-Recorder.9eaa86ef.png";